export default __webpack_public_path__ + "static/media/Newsletter 021.c847fdda.png";